import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { LogoUrlField } from '../fields/LogoUrl';
import {
  logoUrlUiOptionsSchema,
  logoUrlValueSchema,
} from '../schemas/logoUrlSchema';

export const logoUrlFieldExtension: any = FormFieldBlueprint.make({
  name: 'logo-url-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'LogoUrlPicker',
        component: LogoUrlField,
        schema: makeFieldSchema({
          output: () => logoUrlValueSchema,
          uiOptions: () => logoUrlUiOptionsSchema,
        }),
      }),
  },
});
